<script>
export default {
    name: "RawData",
    props: {
        data: {
            type: Object,
            default: () => null,
        },
        placement: {
            type: String,
            default: "left",
        },
        keyId: {
            type: String,
            default: "",
        },
        exclude: {
            type: Array,
            default: () => [],
        },
    },
    data(){
        return {
            filter: "",
        }
    },
    computed: {
        rawData() {
            if(!this.data) return "";
            let result = JSON.parse(JSON.stringify(this.data));
            this.exclude.forEach((item) => {
                delete result[item];
            });
            if(this.filter){
                const filter = this.filter.toLowerCase();
                const filteredResult = {};
                Object.keys(result).forEach((key) => {
                    if(key.toLowerCase().includes(filter) || String(result[key]).toLowerCase().includes(filter)){
                        filteredResult[key] = result[key];
                    }
                });
                return JSON.stringify(filteredResult, null, 2);
            }
            return JSON.stringify(result, null, 2);
        },
        reversePlacement() {
            if(this.placement === "left"){
                return "right";
            }
            if(this.placement === 'bottom'){
                return "bottom";
            }
            return this.placement;
        },
    },
    methods: {
        viewCode(data) {
            this.$emit("view-code", data)
        },
    }
}
</script>
<template>
    <div 
        class="position-absolute" 
        style="top:-5px;"
        :style="placement.includes('left') ? 'left:-5px;' : 'right:-5px;'"
    >
        <a 
            href="javascript:void(0);" 
            @click.stop="viewCode(data)"
            :id="`view-code-${!keyId ? data.id : keyId}`"
        >
            <i class="bx bx-code-alt fs-4"></i>
        </a>
        <b-popover 
            :target="`view-code-${!keyId ? data.id : keyId}`"
            triggers="click blur"
            :placement="reversePlacement"
            custom-class="popover-code"
        >
            <div>
                <input type="text" class="form-control form-control-sm" v-model="filter" placeholder="Search key or value of object">
            </div>
            <div>
                <pre class="font-size-12">{{ rawData }}</pre>
            </div>
        </b-popover>
    </div>
</template>